import noise3D from '../noise3D.ts'
import dithering from './bayer.frag.ts'

export default /* glsl */ `${noise3D + dithering}
uniform float uTime;
uniform sampler2D uDitheringTexture;
uniform vec2 uResolution;
uniform vec3 uProgress;

void main(){
  vec2 st = floor(gl_FragCoord.xy / 4.0);
  vec2 uv = st / (uResolution / 4.0);
  uv -= 0.5;
  uv.x *= uResolution.x / uResolution.y;
  uv += 0.5;
  float n = noise(vec3(uv * 1.3 + (uTime + uProgress.x * 20.0) * 0.1, (uTime + uProgress.x * 20.0) * 0.1));
  n = smoothstep(0.3, 1.0, n);

  float dithering = texture2D(uDitheringTexture, st / 8.0).r;
  float grayscale = step(dithering + 0.01, n);
  gl_FragColor = vec4(grayscale, dithering, 0.0, 1.0);
}
`
